import { Component, NgZone } from "@angular/core";
import { localDataService, localDataServices } from "../../Services/localDataServices";
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { C } from "@angular/core/src/render3";
import { promise } from "protractor";
import { resolve } from "url";
import { PromiseType } from "protractor/built/plugins";
declare var $: any;  //定义jquery
declare var async: any;  //定义jquery
@Component({
    selector: 'customsDeclarations',
    providers: [localDataServices],
    templateUrl: './customsDeclarations.html',
    styleUrls: ['./customsDeclarations.css']
})

export class customsDeclarationsComponent {
    tabs: 'tabs1' | 'tabs2' = 'tabs1';
    isFillLayout: boolean = false;
    token: string;
    orderNo: string;
    delays: number = 20;
    setDelays: number = 20;
    modalVibisity: boolean = false;
    attrJson: any = {
        invSeller:{
            value:'',
            rows:[]
        },
        invBuyer:{
            value:'',
            rows:[]
        },
        originalCountry:{
            value:'',
            rows:[]
        },
        invOriginalCountry:{
            value:'',
            rows:[]
        },
        portOfLoading:{
            value:'',
            rows:[]
        },
        distinatePort:{
            value:'',
            rows:[]
        },
        invoiceAmount:{
            value:'',
            rows:[]
        },
        invoiceCurrency:{
            value:'',
            rows:[]
        },
        transMode:{
            value:'',
            rows:[]
        },
        tableList:[]
    };
    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _localDataService: localDataService,
        private _location: Location,
        private ngZone: NgZone,

    ) {

    }

    ngOnInit() {
        this._activatedRoute.queryParams.subscribe(params => {
            if (params.delays > 0) {
                this.delays = params.delays;
                this.setDelays = params.delays;
            }
        })


        this._activatedRoute.params.subscribe((params => {
            this.orderNo = params.orderNo;
            this.identifyData(params);
            // this.getSomeType();
        }))


    }
    ngAfterContentInit() {
        $('#myModal').on('hidden.bs.modal', (e) => {
            this.ngZone.run(() => {
                this.openModalType = null;
                this.focusIdx = -1
                this.checkedIdx -1
                document.querySelector('.modal-body-table').scrollTop = 0
            })
        })
        $('#exampleModal').on('hidden.bs.modal', (e) => {
            this.ngZone.run(() => {
                this.portForm = { portName: '', portCode: '' };
                this.portVName = false;
                this.portVCode = false;
                this.portCodeArray = [];
            })
        })
    }

    invoiceImg = []
    packingListImg = []
    imgUrl = ''
    // 获取 单证数据 
    identifyData(params: any = { orderNo: this.orderNo }) {
        this.modalVibisity = true;
        if (this.delays !== this.setDelays) { this.delays = this.setDelays }
        let timer = setInterval(() => {
            if (this.delays <= 0) { return clearInterval(timer) }
            this.delays--;
        }, 1000)

        this._localDataService.customsDeclarationsDetail(params)
            .then((res: any) => {
                let { status, data, message } = res;
                if (status) {
                    let url = window.location.href
                    if(url.includes('doc.autoport')) {
                        this.imgUrl = 'http://uploadall.oss-cn-shanghai.aliyuncs.com/'
                    }else {
                        this.imgUrl = 'http://dev-uploadall.oss-cn-shanghai.aliyuncs.com/'
                    }
                    this.attrJson = data.userJson;
                    this.invoiceImg = this.attrJson.docImageSrc.INVOICE || []
                    this.packingListImg = this.attrJson.docImageSrc.PACKING_LIST || []
                    clearInterval(timer);
                    this.modalVibisity = false;
                }else {
                    clearInterval(timer);
                    this.modalVibisity = false;
                    alert(message)
                }
            })
    }
    // 保存
    updataHander(event, setType) {
        let $btn = $(event.target).button('loading')
        this._localDataService.saveIdentDetails({ token: this.token, orderNo: this.orderNo, msCoID: this.msCoID, orderStatus: setType, attrJson: this.attrJson })
            .then((res: any) => {
                let { code, message } = res;
                alert((setType ? '发送' : '保存') + message)
                $btn.button('reset');
            })
    }
    msCoID: any;
    getSomeType() {
        // this._localDataService.getThisCompanyHaveSomeType(this.token).then((res: any) => {
        //     if (res.status) {
        //         this.msCoID = res.data.filter((item) => item.code === 'W0001')[0]['coBizId'];
        //     } else {
        //         console.log(res.message);
        //     }
        // })
    }
    // 图片缩放功能
    degNum: number = 1;
    // 图片放大 
    onBig(className,type) {
        // if (this.degNum <= 2) {
        //     this.degNum = this.degNum + 0.2
        // }
        let obj = $('.' + className).find('img');
    
        let ww = Number(obj.width())
        obj.css("width", (ww + 80) + "px")
    }
    // 图片缩小
    onSmall(className) {
        // if (this.degNum > 0.2) {
        //     this.degNum = this.degNum - 0.2;
        // }
        let obj = $('.' + className).find('img');
    
        let ww = Number(obj.width())
        obj.css("width", (ww - 80) + "px")
    }
    lineWidth: string = '0px'
    lineHeight: string = '0px'
    lineTop: string = '0px'
    lineLeft: string = '0px'
    // input focus 标记 红色位置
    drawTag(rows) {
        $('.img-outline').hide()
        $('.tib').eq(0).css('color','rgba(0, 0, 0, 0.65)')
        $('.tib').eq(1).css('color','rgba(0, 0, 0, 0.65)')
        if(!rows || rows.length == 0) return
        rows.forEach((item,index) => {
            if(item.docType == "INVOICE") {
                $('.tib').eq(0).css('color','#1784fc')
            }else if(item.docType == "PACKING_LIST") {
                $('.tib').eq(1).css('color','#1784fc')
            }
            $('.' + item.imgSrc.replace('/','').replace('.','') + ' .img-outline').show()
            let imgwidth = $('.' + item.imgSrc.replace('/','').replace('.','')).find('img').css("width").split("px")[0];
            console.log(Number(item.right - item.left) * Number(imgwidth / item.width))
            $('.' + item.imgSrc.replace('/','').replace('.','') + ' .img-outline').css('width', Number(item.right - item.left) * Number(imgwidth / item.width) + 'px');
            $('.' + item.imgSrc.replace('/','').replace('.','') + ' .img-outline').css('height', Number(item.bottom - item.top) * Number(imgwidth / item.width) + 'px');
            $('.' + item.imgSrc.replace('/','').replace('.','') + ' .img-outline').css('top', Number(item.top) * Number(imgwidth / item.width) + 'px');
            $('.' + item.imgSrc.replace('/','').replace('.','') + ' .img-outline').css('left', Number(item.left) * Number(imgwidth / item.width) + 'px');
        })
        
    }
    // 清除 标记
    clearTag() {
        this.lineWidth = '0px'
        this.lineHeight = '0px'
        this.lineTop = '0px'
        this.lineLeft = '0px'
    }
    // 固定宽度1200  切换
    onLayoutHander() {
        this.isFillLayout = !this.isFillLayout
    }
    // tabs 切换 
    onceSetIframeScore = null;
    onTab(activeTab) {
        this.tabs = activeTab;
        if (activeTab === 'tabs2') {
            // if($('.pdfDiv').html().includes('iframe')) return
            // $('.pdfDiv').html('')
            // this._localDataService.getCustomsDeclarationsPdf({ imgPath: this.attrJson.imageList })
            //      .then((res:any) => {
            //         const { status, data} = res
            //         if(status) {
            //             data.forEach(item => {
            //                $('.pdfDiv').append(
            //                 `
            //                 <iframe class="iframeScore" width="100%" style="height: 800px;" frameborder="0" src="${item.pdf}"></iframe>
            //                 `
            //                )
            //             })
            //         }
            //      })
        }
    }

    drawLoading() {
        let cvs = <HTMLCanvasElement>document.getElementById('loading-canvans');
        cvs.width = 1200;
        cvs.height = 800;
        let cvsCxt = cvs.getContext('2d');
        cvsCxt.arc(0, 0, 360, 0, 360)
        cvsCxt.stroke();
    }

    openModalType = null;
    openModalName = '';
    // 获取对应的五字码
    onKeyUpHander(event, type) {
        event.preventDefault();
        event.stopPropagation();
        this.openModalType = type;
        this.openModalName = event.target.previousSibling.previousSibling.innerText.replace(/[A-z]/g, '');
        event.target.blur()
        this._localDataService.getCodeByName({ portName: event.target.value, token: this.token })
            .then((res: any) => {
                console.log(res);

                const { code, data, message } = res;
                if (code !== 200) {
                    return alert(message);
                }
                this.attrJson[type].value = data;
                if (data === '') {
                    $('#myModal').modal('show');
                    this.searchForm.portName = event.target.value;
                    this.onMPSearchHander(event);
                }
            })
    }
    tableData: any = [];
    searchForm: any = { portName: '', portCode: '' };
    onMPSearchHander(event) {
        try {
            this._localDataService.getPostCodeList({ ...this.searchForm, token: this.token })
                .then((res: any) => {
                    console.log(res);

                    const { code, data, message } = res;
                    if (code !== 200) {
                        return alert(message)
                    }
                    if (data.length > 0) {
                        this.tableData = data;
                        this.onClickTd(null, 0)
                        return
                    }
                    this.tableData = data;
                    this.checkedIdx = -1
                })
        } catch (error) {
        }

    }

    // td 点击
    checkedIdx: number = 0;
    focusIdx: number = 0;
    hasKeyEvent = null;
    onClickTd(event, tdIdx) {
        this.checkedIdx = tdIdx;
        this.bindBoard()
    }
    bindBoard() {
        const modalEl = document.querySelector('#myModal');
        if (this.hasKeyEvent) {
            modalEl.removeEventListener('keyup', this.hasKeyEvent, true);
        }
        const ctxBoard = this.tableBoard(this.checkedIdx);
        this.hasKeyEvent = ctxBoard;
        modalEl.addEventListener('keyup', ctxBoard, true);
    }
    tableBoard(checkedIdx) {
        let tdIdx = checkedIdx;
        let scrollElement = document.querySelector('.modal-body-table') as HTMLElement;
        let tr = scrollElement.querySelectorAll('tr');
        let scrollHeight = scrollElement.offsetHeight;
        return (event) => {
            event.preventDefault()
            event.stopPropagation()
            if (this.portNameEnter(event) === false) {
                return
            }; // 港口名称 回车

            if (event.target.tagName === 'INPUT' && event.keyCode === 13) {
                event.target.blur()
                this.onMPSearchHander(event);
                return;
            }
            if (event.target.tagName === 'BUTTON' && event.keyCode === 13) {
                return;
            }
            if (this.tableData.length) {
                // 向上
                if (event.keyCode === 38 && tdIdx) {
                    tdIdx--;
                    if ((tr[tdIdx].offsetTop - scrollHeight / 2) <= scrollElement.scrollTop) {
                        scrollElement.scrollTop = tr[tdIdx].offsetTop-scrollHeight / 2 ;
                    }
                }
                // 向下
                if (event.keyCode === 40 && tdIdx < this.tableData.length - 1) {
                    tdIdx++;
                    if ((tr[tdIdx].offsetTop - scrollHeight / 2) > scrollElement.scrollTop) {
                        scrollElement.scrollTop = tr[tdIdx].offsetTop-scrollHeight / 2 ;
                    }
                }
                this.focusIdx = tdIdx;
                if (event.keyCode === 13 && tdIdx !== this.checkedIdx) {
                    this.checkedIdx = tdIdx;
                } else if (event.keyCode === 13 && tdIdx === this.checkedIdx) {
                    this.backfill();
                }
            }
        }
    }
    portNameEnter(event) {
        if (event.target.tagName === 'INPUT' && event.keyCode === 13) {
            event.target.blur()
            this.onMPSearchHander(event);
            return false;
        }
        if (event.target.tagName === 'BUTTON' && event.keyCode === 13) {
            return false;
        }

    }
    verifyMpCode(event, type) {
        this._localDataService.getCodeByName({ portName: event.target.value, token: this.token })
            .then((res: any) => {
                console.log(res);

                const { code, data, message } = res;
                if (code !== 200) {
                    return alert(message);
                }
                this.attrJson[type].value = data;
            })
    }
    backfill() {
        const data = this.tableData.filter((it, idx) => idx === this.checkedIdx)
        try {
            if (data.length) {
                const mp = this.openModalType;
                const name = this.openModalType.replace('MP', '');
                this.attrJson[mp].value = data[0].portCode || '';
                this.attrJson[name].value = data[0].portName || '';
            }
        } catch (error) {
            alert('回车选中数据失败请开发者检查')
        }
        $('#myModal').modal('hide')
    }
    portForm = { portName: '', portCode: '' }
    portVName = false;
    portVCode = false;
    updateOrAddPortCode() {
        if (this.portForm.portName === '') {
            this.portVName = true;
            return;
        }
        this.portVName = false;
        if (!/^[A-Z]{5}$/.test(this.portForm.portCode)) {
            this.portVCode = true;
            return;
        }
        this.portVCode = false;
        this._localDataService.updateOrAddPortCode({ ...this.portForm, token: this.token })
            .then((res: any) => {
                const { code, data, message } = res;
                if (code !== 200) {
                    return alert(message);
                }
                alert(message);
                $('#exampleModal').modal('hide')
            })


    }
    portCodeArray: any[] = []
    dorpDown: boolean = false
    portCodeInput() {
        if (this.searchForm.portCode !== '') {
            this._localDataService.getCodeByCode({ portCode: this.searchForm.portCode, token: this.token })
                .then((res: any) => {
                    const { code, data, message } = res;
                    if (code !== 200) {
                        return alert(message)
                    }
                    this.dorpDown = true;
                    this.portCodeArray = data;

                })
        } else {
            this.dorpDown = false;
            this.portCodeArray = [];
        }

        console.log('input1');
    }
    throttle(fn, second) {
        if (fn.timer) {
            clearTimeout(fn.timer);
        }
        fn.timer = setTimeout(() => {
            fn.call(this)
        }, second)
    }
    portCodeBlur(event) {
        setTimeout(() => {
            this.dorpDown = false
        }, 200)
    }
    deletePortCode(event, mp) {
        debugger
        event.stopPropagation();
        const { id, portType } = mp
        if (id && portType) {
            this._localDataService.deletePortCode({ id: id, token: this.token })
                .then((res: any) => {
                    const { code, data, message } = res
                    if (code !== 200) {
                        return alert(message);
                    }
                    alert(message)
                    this.onMPSearchHander(event)
                })
        }
    }
}



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/component/customsDeclarations/customsDeclarations.ts